/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpsertKeyRequestBody = {
  /**
   * The provider API key. Stored encrypted at rest; never returned on reads.
   */
  apiKey: string;
  /**
   * Whether the key participates in key resolution.
   */
  enabled?: boolean | undefined;
  /**
   * The model provider the key authenticates with. Supported values include openrouter.
   */
  provider: string;
  /**
   * The responsibility slot the key applies to. Use 'default' to cover every slot without a dedicated override.
   */
  slot: string;
};

/** @internal */
export type UpsertKeyRequestBody$Outbound = {
  api_key: string;
  enabled: boolean;
  provider: string;
  slot: string;
};

/** @internal */
export const UpsertKeyRequestBody$outboundSchema: z.ZodMiniType<
  UpsertKeyRequestBody$Outbound,
  UpsertKeyRequestBody
> = z.pipe(
  z.object({
    apiKey: z.string(),
    enabled: z._default(z.boolean(), true),
    provider: z.string(),
    slot: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apiKey: "api_key",
    });
  }),
);

export function upsertKeyRequestBodyToJSON(
  upsertKeyRequestBody: UpsertKeyRequestBody,
): string {
  return JSON.stringify(
    UpsertKeyRequestBody$outboundSchema.parse(upsertKeyRequestBody),
  );
}
